/** * Description: * This is component used to VSA EOM (End of month) Management
report for Admin * * Copyright:VSA & Samath IT Solutions * Contact email:
support@samath.com.au * * Authors: * Hiro * * Date:20220205 */
<template>
  <div class="iq-card pl-3 pr-3 pt-5 pb-5">
    <div id="report-4">
      <div class="">
        <table style="width: 100%">
          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr>
                <th style="width: 25%">
                  <div class="logo">
                    <img
                      src="../../../assets/images/vehicle-solutions-logo-type1.png"
                      class="img-fluid"
                    />
                  </div>
                </th>
                <th style="width: 75%">
                  <div class="text-right">
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      VSA EOM
                    </h4>
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      Management
                    </h4>
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      Report
                    </h4>
                    <p
                      style="
                        font-weight: 700;
                        margin-top: 20px;
                        margin-bottom: 0;
                      "
                    >
                      {{ propsFromDate | dateConvertDDMMYYYY }} to
                      {{ propsToDate | dateConvertDDMMYYYY }}
                    </p>
                  </div>
                </th>
              </tr>
            </table>
          </tr>

          <tr v-if="comGetRptData">
            <table style="width: 100%; margin: 0; padding: 0; margin-top: 25px">
              <tr class="tbl-header-blue">
                <th>Customer Name</th>
                <th class="tbl-right">NAF</th>
                <th class="tbl-right">Commission</th>
                <th class="tbl-right">Fee</th>
                <th class="tbl-right">Total</th>
              </tr>
              <tr class="tbl-tr-no-data">
                <td colspan="5"></td>
              </tr>

              <template v-for="dealer in comGetRptData">
                <tr class="tbl-header-gray">
                  <td colspan="5">
                    Finance Manager - {{ dealer[0].created_user.firstName }} -
                    {{ dealer[0].dealer.name }}
                  </td>
                </tr>
                <template v-for="record in dealer">
                  <tr class="tbl-border-bottom">
                    <td>
                      {{
                        record.client.firstName + ' ' + record.client.lastName
                      }}
                    </td>
                    <td class="tbl-right">
                      $ {{ record.totalDriveAwayCost | with-decimal}}
                    </td>
                    <td class="tbl-right">
                      $ {{ fnGetVSACommission(record) | with-decimal }}
                    </td>
                    <td class="tbl-right">
                      $
                      {{ record.client_lookup_values.leaseAdminFeeVSA |with-decimal}}
                    </td>
                    <td class="tbl-right" v-if="record.client_lookup_values">
                      $
                      {{ fnTotalVSACommissionReportable(record) | with-decimal }}
                    </td>
                  </tr>
                </template>
                <tr class="tbl-tr-no-data">
                  <td colspan="5"></td>
                </tr>
              </template>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="tbl-right">TOTAL</td>
                <td class="tbl-right">
                  $ {{ Number(comGetTotal)  |with-decimal}}
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
@page {
  /* size: A4 portrait; */
  /* margin: 0cm 0cm; */
  width: 210mm;
  height: 290mm;
  margin: 0px 20px 0px 20px;
}
@media print {
  body * {
    visibility: hidden !important;
  }
  #reportConsoleLeftSide {
    display: none !important;
  }
  #reportConsoleRightSide.col-lg-8,
  #reportConsoleRightSide.col-md-8 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  #report-4,
  #report-4 * {
    visibility: visible !important;
  }
  #report-4 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    margin: 0;
    /* width: 210mm; */
    /* height: 297mm; */
  }
}
#report-4 .logo img {
  height: 125px !important;
  width: auto;
  border-radius: 0px;
}
#report-4 .img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
#report-4 .tbl-header-blue {
  background-color: var(--iq-info);
  color: var(--iq-white);
}
#report-4 .tbl-header-gray {
  background-color: var(--iq-border-light);
  color: var(--iq-title-text);
}
#report-4 .tbl-header-blue th,
#report-4.tbl-header-gray td,
#report-4 td {
  font-size: 1.1rem;
}
#report-4 tr th,
#report-4 tr td {
  padding: 15px;
}
#report-4 tr.tbl-tr-no-data td {
  padding: 10px;
}
#report-4 tr.tbl-tr-no-data30-gray td {
  padding: 30px;
  background-color: var(--iq-border-light);
}
#report-4 .tbl-border-bottom {
  border-bottom: 1px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom3 {
  border-bottom: 3px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom4 {
  border-bottom: 3px solid var(--iq-info);
}
#report-4 .tbl-left {
  text-align: left;
}
#report-4 .tbl-right {
  text-align: right;
}
#report-4 .tbl-center {
  text-align: center;
}

#report-4 .footer {
  position: relative;
  bottom: 0;
}

#report-4 tr td p {
  font-size: 1.1rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-info {
  color: #38afef;
}
.fw-600 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../../services/auth.service'
import appModalQuoteEmailOptions from '../../quote/ModalQuoteEmailOptions.vue'
export default {
  name: 'VSAEOMManagementReport',
  props: ['prosData', 'propsDealerIds', 'propsFromDate', 'propsToDate'],
  components: {
    appModalQuoteEmailOptions
  },
  data() {
    return {
      userData: {},
      data: [],
      filterData: []
    }
  },
  computed: {
    comGetRptData() {
      let arr = this.prosData
      let groupBy = (array, key) => {
        return array.reduce((result, obj) => {
          ;(result[obj[key]] = result[obj[key]] || []).push(obj)
          return result
        }, {})
      }

      let sortFilter = (a, b) => {
        return a.client.dealerId - b.client.dealerId
      }

      let a = groupBy(arr.sort(sortFilter), 'createdBy')
      let b = Object.values(a)
      this.filterData = arr
      return b
    },
    comGetTotal() {
      let arr = this.filterData
      let totalPrice = arr.reduce((accumulator, item) => {
        return (
          accumulator +
          (Number(this.fnGetVSACommission(item)) +
            Number(item.client_lookup_values.leaseAdminFeeVSA))
        )
      }, 0)
      return totalPrice
    }
  },
  methods: {
    fnPrintMe() {
      window.print()
    },
    fnGetVSACommission(record) {
      let totalDriveAwayCost = 0
      let gst = 0 //gstOnAsset
      let estabFee = 0 //McLease fee
      let ppsr = 0 //PPSR fee
      let originationFee = 0 //Lease admin fee VSA
      let totalBrokerage = 0
      let vsaBrokerage = 0
      let dealerBrokerage = 0
      let totalDealershipCommission = 0
      let brokerageIncGST = 0
      let vsaCommission = 0

      if (record.client_lookup_values.brokerageVSA) {
        vsaBrokerage = record.client_lookup_values.brokerageVSA
      }

      if (record.dealerBrokerage) {
        dealerBrokerage = record.dealerBrokerage
      }

      if (record.totalDriveAwayCost) {
        totalDriveAwayCost = record.totalDriveAwayCost
      }
      if (record.gstOnAsset) {
        gst = record.gstOnAsset
      }

      if (record.client_lookup_values.PPSRFee) {
        ppsr = record.client_lookup_values.PPSRFee
      }

      if (record.client_lookup_values.mcLeaseFee) {
        estabFee = record.client_lookup_values.mcLeaseFee
      }

      if (record.client_lookup_values.leaseAdminFeeVSA) {
        originationFee = record.client_lookup_values.leaseAdminFeeVSA
      }

      totalBrokerage =
        (Number(totalDriveAwayCost) -
          Number(gst) +
          Number(estabFee) +
          Number(ppsr) +
          Number(originationFee)) *
        Number(Number(vsaBrokerage) + Number(dealerBrokerage))

      totalDealershipCommission =
        Number(totalDriveAwayCost) * Number(dealerBrokerage)

      brokerageIncGST =
        Number(totalBrokerage) * Number(this.fnGSTRatePercentage100(record))

      vsaCommission =
        Number(brokerageIncGST) - Number(totalDealershipCommission)

      return vsaCommission
    },

    //Total VSA Commission Reportable
    fnTotalVSACommissionReportable(record) {
      let originationFee = 0 //Lease admin fee VSA

      if (record.client_lookup_values.leaseAdminFeeVSA) {
        originationFee = record.client_lookup_values.leaseAdminFeeVSA
      }

      return Number(this.fnGetVSACommission(record)) + Number(originationFee)
    },

    /**
     * if broker is VSA then total brokerage, dealer id = 73
     * VSA 5% + VSA Dealer 5% - Full commissions
     * if other (just Dealer )
     * VSA 5% +Dealer 3% - need to compare commissions
     */
    fnGetTotalBrokerage(record) {
      let vsaBrokerage = 0
      let dealerBrokerage = 0

      if (record.client_lookup_values.brokerageVSA) {
        vsaBrokerage = record.client_lookup_values.brokerageVSA
      }

      if (record.dealerBrokerage) {
        dealerBrokerage = record.dealerBrokerage
      }

      return Number(vsaBrokerage) + Number(dealerBrokerage)
    },

    // GST Rate 1.1
    fnGSTRatePercentage100(record) {
      let gstRate100 = 0
      let gstRate100Percentage = 0

      if (record.client_lookup_values.GST) {
        gstRate100 = record.client_lookup_values.GST
      }

      gstRate100Percentage = 1 + Number(gstRate100)

      return gstRate100Percentage
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>
